<ng-container *ngIf="navLinks?.children">
  <li
    *ngFor="let navLink of navLinks?.children; let i = index"
    class="dropdown main-nav mob-dot-cms-main-custom-menu"
    [ngClass]="{ open: isOpened(navLink) }"
  >
    <!-- Checking Folder or Page -->
    <ng-container *ngIf="navLink.type !== 'folder'; else folderNav">
      <a [routerLink]="dotCMSHeaderNavigationLink(navLink.href)">{{ navLink.title }}</a>
    </ng-container>
    <!-- Folder's Code start -->
    <ng-template #folderNav>
      <ng-container *ngIf="navLink?.children?.length > 0; else folderWithNoPages">
        <li
          #folder
          (mouseenter)="showFlyout(folder)"
          (mouseleave)="hideFlyout(folder)"
          class="dropdown main-nav mob-dot-cms-custom-menu"
          [ngClass]="{ open: isOpened(navLink) }"
        >
          <custom-dot-cms-header-folder-index-page-check
            [navLink]="navLink"
          ></custom-dot-cms-header-folder-index-page-check>
          <ng-container *ngIf="0 < mainNavigationMaxSubFoldersDepth && navLink.children.length > 0">
            <a
              [routerLink]="[]"
              (click)="toggleOpen(navLink)"
              [attr.aria-label]="isOpened(navLink) ? 'collapse ' + navLink.title : 'expand ' + navLink.title"
              class="dropdown-toggle"
            >
              <fa-icon *ngIf="isOpened(navLink); else closed" [icon]="['fas', 'minus']"></fa-icon>
              <ng-template #closed><fa-icon [icon]="['fas', 'plus']"></fa-icon></ng-template>
            </a>
            <custom-dot-cms-sub-folder-header-navigation
              [subFolderItems]="navLink.children"
              [depth]="1"
            ></custom-dot-cms-sub-folder-header-navigation>
          </ng-container>
        </li>
      </ng-container>
      <ng-template #folderWithNoPages>
        <div class="mob-dot-cms-custom-menu">
          <div class="mob-disable-links">{{ navLink.title }}</div>
        </div>
      </ng-template>
    </ng-template>
  </li>
</ng-container>
